import React from 'react';

/**
 * Personality icon - a cute pet face with a sparkle,
 * suggesting "unique character" without being a weird mask.
 */
export default function PersonalityIcon({ size = 24, color = 'currentColor', className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Pet face circle */}
      <circle cx="12" cy="13" r="8" stroke={color} strokeWidth="1.5" />
      {/* Ears */}
      <path d="M6.5 7L4 2.5L8.5 5.5" fill={color} opacity="0.3" />
      <path d="M17.5 7L20 2.5L15.5 5.5" fill={color} opacity="0.3" />
      {/* Eyes - one winking to show personality */}
      <circle cx="9.5" cy="12" r="1.2" fill={color} />
      <path d="M13.5 12.5C13.5 12.5 14.5 11.5 15.5 12.5" stroke={color} strokeWidth="1.3" strokeLinecap="round" />
      {/* Smile */}
      <path d="M9 16C9 16 10.5 17.5 12 17.5C13.5 17.5 15 16 15 16" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
      {/* Sparkle (personality/uniqueness) */}
      <path d="M19 3L19.5 5L20 3L20.5 5L21 3" stroke={color} strokeWidth="0.8" strokeLinecap="round" />
      <path d="M20 2L20 4M19.2 3L20.8 3" stroke={color} strokeWidth="0.9" strokeLinecap="round" />
    </svg>
  );
}
